import React from "react";
import { useMyContext } from "src/hooks/context";
import ReactLoading from "react-loading";

const formatter = (value) => {
  return value ? value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null;
};

const Info = () => {
  const { state } = useMyContext();

  return (
    <div className="w-full h-full flex flex-col items-center bg-white rounded-lg shadow-lg p-2 md:md:w-2/5 overflow-x-auto">
      <div className="w-full text-center font-bold border-b p-3 mb-4 text-md text-white bg-teal-500 rounded-t-md">
        Ерөнхий мэдээлэл
      </div>

      {state.loading ? (
        <div className="w-full h-full items-center justify-center flex flex-column flex-wrap bg-transparent">
          <ReactLoading type="bars" color="teal" />
          <div className="absolute mt-16">
            <h3>Уншиж байна...</h3>
          </div>
        </div>
      ) : (
        <>
          <div className="w-full flex border-b p-2">
            <div className="w-48">Овог, нэр</div>
            <div className="font-medium">{state?.info?.name}</div>
          </div>
          <div className="w-full flex border-b p-2">
            <div className="w-48">Цех</div>
            <div className="font-medium">{state?.info?.department}</div>
          </div>
          <div className="w-full flex border-b p-2">
            <div className="w-48">Хэсэг, нэгж</div>
            <div className="font-medium">{state?.info?.unit_name}</div>
          </div>
          <div className="w-full flex border-b p-2">
            <div className="w-48">Албан тушаал</div>
            <div className="font-medium">{state?.info?.position}</div>
          </div>

          {/* <div className="w-full flex border-b p-2">
            <div className="w-48">Ажлын цаг</div>
            <div className="font-medium">{state?.info?.total_hours}</div>
          </div>
          <div className="w-full flex border-b p-2">
            <div className="w-48">Ажилласан цаг</div>
            <div className="font-medium">{state?.info?.worked_hours}</div>
          </div> */}
          <div className="w-full flex border-b p-2">
            <div className="w-48">Нийт нэмэгдэл</div>
            <div className="font-medium text-green-600">
              {formatter(state?.info?.sumDebit)}
            </div>
          </div>
          <div className="w-full flex border-b p-2">
            <div className="w-48">Нийт суутгал</div>
            <div className="font-medium text-red-600">
              {formatter(state?.info?.sumCredit)}
            </div>
          </div>
          <div className="w-full flex border-b p-2 bg-gray-100">
            <div className="w-48">Гарт олгох</div>
            <div className="font-medium text-green-600">
              {formatter(state?.info?.sumDiffrence)}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Info);
